// extracted by mini-css-extract-plugin
export default {"formHeading":"kP-z","form":"lP-z","submitBtn":"mP-z","disabled":"nP-z","input":"oP-z","error":"pP-z","submitMsg":"qP-z","signIn":"rP-z"};